function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { ALGOLIA_PRICE_ATTRIBUTE } from './constants';
import { mergePreselectedDefaults } from './parse-default-filters';

/**
 * Lightweight state manager for Algolia PLP with optional URL synchronisation.
 *
 * State shape:
 *   { query, refinements, numericRange, sortIndex, page }
 *
 * Every mutator emits `'stateChange'` so the search layer can react.
 */

// ---------------------------------------------------------------------------
// Minimal EventEmitter
// ---------------------------------------------------------------------------

class Emitter {
  constructor() {
    this._listeners = {};
  }
  on(event, fn) {
    var _this$_listeners;
    ((_this$_listeners = this._listeners)[event] || (_this$_listeners[event] = [])).push(fn);
    return this;
  }
  off(event, fn) {
    var list = this._listeners[event];
    if (!list) return this;
    this._listeners[event] = list.filter(f => f !== fn);
    return this;
  }
  emit(event) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    var list = this._listeners[event];
    if (list) list.forEach(fn => fn(...args));
  }
}

// ---------------------------------------------------------------------------
// URL helpers
// ---------------------------------------------------------------------------

var PARAM_QUERY = 'q';
var PARAM_PAGE = 'page';
var PARAM_SORT = 'sort';
function sortLabelFromIndex(sortReplicas, indexName) {
  var match = sortReplicas.find(r => r.value === indexName);
  return match ? match.urlKey || slugify(match.label) : null;
}
function sortIndexFromLabel(sortReplicas, label) {
  var match = sortReplicas.find(r => (r.urlKey || slugify(r.label)) === label);
  return match ? match.value : null;
}
function slugify(str) {
  return String(str).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
}
function stateToUrl(state, config) {
  var params = new URLSearchParams();
  if (state.query) params.set(PARAM_QUERY, state.query);
  for (var _ref3 of Object.entries(state.refinements)) {
    var _ref2 = _slicedToArray(_ref3, 2);
    var attr = _ref2[0];
    var values = _ref2[1];
    if (values.length) params.set(attr, values.join(','));
  }
  var nr = state.numericRange;
  for (var _ref6 of Object.entries(nr)) {
    var _ref5 = _slicedToArray(_ref6, 2);
    var _attr = _ref5[0];
    var range = _ref5[1];
    if (range.min != null) params.set("".concat(_attr, "_min"), String(range.min));
    if (range.max != null) params.set("".concat(_attr, "_max"), String(range.max));
  }
  if (state.sortIndex && state.sortIndex !== config.defaultSortIndex) {
    var label = sortLabelFromIndex(config.sortReplicas, state.sortIndex);
    if (label) params.set(PARAM_SORT, label);
  }
  if (state.page > 1) params.set(PARAM_PAGE, String(state.page));
  var qs = params.toString();
  return qs ? "".concat(window.location.pathname, "?").concat(qs) : window.location.pathname;
}
function stateFromUrl(config) {
  var params = new URLSearchParams(window.location.search);
  var refinements = {};
  var numericRange = {};
  var facetAttrs = new Set(config.facets.filter(f => f.type === 'refinementList' || f.type === 'colorSwatches').map(f => f.attribute));
  var numericAttrs = new Set(config.facets.filter(f => f.type === 'rangeInput').map(() => ALGOLIA_PRICE_ATTRIBUTE));
  for (var _ref9 of params.entries()) {
    var _ref8 = _slicedToArray(_ref9, 2);
    var key = _ref8[0];
    var val = _ref8[1];
    if (facetAttrs.has(key)) {
      refinements[key] = val.split(',').map(v => v.trim()).filter(Boolean);
    }
  }
  for (var attr of numericAttrs) {
    var minVal = params.get("".concat(attr, "_min"));
    var maxVal = params.get("".concat(attr, "_max"));
    if (minVal != null || maxVal != null) {
      numericRange[attr] = {
        min: minVal != null ? Number(minVal) : null,
        max: maxVal != null ? Number(maxVal) : null
      };
    }
  }
  var sortLabel = params.get(PARAM_SORT);
  var sortIndex = config.defaultSortIndex;
  if (sortLabel) {
    var resolved = sortIndexFromLabel(config.sortReplicas, sortLabel);
    if (resolved) sortIndex = resolved;
  }
  return {
    query: params.get(PARAM_QUERY) || '',
    refinements,
    numericRange,
    sortIndex,
    page: Math.max(1, Number(params.get(PARAM_PAGE)) || 1)
  };
}

// ---------------------------------------------------------------------------
// AlgoliaState
// ---------------------------------------------------------------------------

export class AlgoliaState extends Emitter {
  /**
   * @param {{ facets: Array, sortReplicas: Array, defaultSortIndex: string, urlSync: boolean, defaultFilters?: ReturnType<import('./parse-default-filters').normalizePreselectedFilters> | null }} config
   */
  constructor(config) {
    super();
    this._config = config;
    var initial = config.urlSync ? stateFromUrl(config) : {
      query: '',
      refinements: {},
      numericRange: {},
      sortIndex: config.defaultSortIndex,
      page: 1
    };
    if (config.defaultFilters) {
      var urlHadSort = config.urlSync ? new URLSearchParams(window.location.search).has(PARAM_SORT) : false;
      initial = mergePreselectedDefaults(initial, config.defaultFilters, {
        urlHadSort,
        defaultSortIndex: config.defaultSortIndex
      });
    }
    this.query = initial.query;
    this.refinements = initial.refinements;
    this.numericRange = initial.numericRange;
    this.sortIndex = initial.sortIndex;
    this.page = initial.page;
    if (config.urlSync) {
      window.addEventListener('popstate', () => {
        var restored = stateFromUrl(config);
        this.query = restored.query;
        this.refinements = restored.refinements;
        this.numericRange = restored.numericRange;
        this.sortIndex = restored.sortIndex;
        this.page = restored.page;
        this.emit('stateChange', this.snapshot());
      });
    }
  }
  snapshot() {
    return {
      query: this.query,
      refinements: _objectSpread({}, this.refinements),
      numericRange: _objectSpread({}, this.numericRange),
      sortIndex: this.sortIndex,
      page: this.page
    };
  }
  _pushUrl() {
    if (!this._config.urlSync) return;
    var url = stateToUrl(this.snapshot(), this._config);
    window.history.pushState(null, '', url);
  }
  _changed() {
    this._pushUrl();
    this.emit('stateChange', this.snapshot());
  }
  setQuery(q) {
    this.query = q;
    this.page = 1;
    this._changed();
  }

  /**
   * Toggle a single value within a facet refinement list.
   * If the value is already selected it is removed; otherwise it is added.
   */
  toggleRefinement(attr, value) {
    var current = this.refinements[attr] || [];
    var idx = current.indexOf(value);
    if (idx === -1) {
      this.refinements[attr] = [...current, value];
    } else {
      var next = current.filter(v => v !== value);
      if (next.length) {
        this.refinements[attr] = next;
      } else {
        delete this.refinements[attr];
      }
    }
    this.page = 1;
    this._changed();
  }

  /**
   * Replace the entire refinement list for an attribute in one operation,
   * avoiding multiple intermediate state-change events.
   */
  setRefinementValues(attr, values) {
    if (!values || !values.length) {
      delete this.refinements[attr];
    } else {
      this.refinements[attr] = [...values];
    }
    this.page = 1;
    this._changed();
  }
  clearRefinement(attr, value) {
    if (!value) {
      delete this.refinements[attr];
    } else {
      var current = this.refinements[attr] || [];
      var next = current.filter(v => v !== value);
      if (next.length) {
        this.refinements[attr] = next;
      } else {
        delete this.refinements[attr];
      }
    }
    this.page = 1;
    this._changed();
  }
  setNumericRange(attr, _ref0) {
    var min = _ref0.min,
      max = _ref0.max;
    var clean = {};
    if (min != null && min !== '') clean.min = Number(min);else clean.min = null;
    if (max != null && max !== '') clean.max = Number(max);else clean.max = null;
    if (clean.min == null && clean.max == null) {
      delete this.numericRange[attr];
    } else {
      this.numericRange[attr] = clean;
    }
    this.page = 1;
    this._changed();
  }
  clearNumericRange(attr) {
    delete this.numericRange[attr];
    this.page = 1;
    this._changed();
  }
  setSort(indexName) {
    if (this.sortIndex === indexName) return;
    this.sortIndex = indexName;
    this.page = 1;
    this._changed();
  }
  setPage(n) {
    var p = Math.max(1, Number(n) || 1);
    if (this.page === p) return;
    this.page = p;
    this._changed();
  }
  clearAll() {
    this.refinements = {};
    this.numericRange = {};
    this.page = 1;
    this._changed();
  }

  /** Total number of active filter selections (for badge counts). */
  get activeFilterCount() {
    var count = Object.values(this.refinements).reduce((sum, v) => sum + v.length, 0);
    count += Object.keys(this.numericRange).length;
    return count;
  }
}